

import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';





export const AutocompleteMultiple = ({ label, options = [], disabled = false, value = [], onChange, ...props }) => {


    const [selectedValues, setSelectedValues] = useState([]);


    useEffect(() => {
        setSelectedValues(value || []);
    }, [value]);



    const handleChange = (newValues) => {
        const newArray = newValues.map((item) => item.id);
        setSelectedValues(newArray);

        if(onChange) { onChange(newArray); }
    };




    return (
        <Autocomplete
            multiple
            options={options}
            value={options.filter((option) => selectedValues.includes(option.id))}
            getOptionLabel={(option) => option.nombre}
            onChange={(_, newValue) => handleChange(newValue)}
            disableCloseOnSelect
            disabled={disabled}
            renderOption={(props, option) => (
                <li {...props} key={option.id}>
                {option.nombre}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                {...params}
                label={label}
                autoComplete="off"
                {...props}
                />
            )}
        />
    );
};
